<template>
    <div style="height: 100%;">
      <div v-if="index === 0" style="height: 100%">
          <DadosCadastrais ref="dadosCadastrais" @validate="changeStep" @complete="emitComplete"/>
      </div>
      <div v-if="index === 1" style="height: 100%">
          <Classificacao ref="classificacao" @validate="changeStep" @complete="emitComplete"/>
      </div>
      <div v-if="index === 2" style="height: 100%; min-height: 300px; width: 888px;">
          <Hierarquia ref="hierarquia" @complete="emitComplete"/>
      </div>
      <div v-if="index === 3" style="height: 100%">
          <Endereco ref="endereco" @complete="emitComplete"/>
      </div>
    </div>
</template>

<script>
import DadosCadastrais from './Shared/DadosCadastrais'
import Classificacao from './Shared/Classificacao'
import Hierarquia from './Shared/Hierarquia'
import Endereco from './Shared/Endereco'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    DadosCadastrais,
    Classificacao,
    Hierarquia,
    Endereco
  },
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showModalAnexo: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit'))
    }
  },
  methods: {
    emitEvent () {
      EventBus.$emit('showAnexo', 'Dados Cadastrais')
    },
    emitComplete () {
      this.$emit('complete')
    },
    async validarCampo () {
      switch (this.index) {
        case (0):
          return this.$refs.dadosCadastrais.validateForm()
        case (1):
          return this.$refs.classificacao.validateForm()
        case (2):
          return this.$refs.hierarquia.salvarHierarquia()
        default:
          return true
      }
    },
    changeStep (validator) {
      if (validator === true) {
        this.$emit('changeIndex')
      }
    }
  }
}
</script>
